(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["native-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('native-delivery-estimate')) {
    customElements.define(
      'native-delivery-estimate',
      class NativeDeliveryEstimate extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-delivery-estimate-variants]');
          const title = this.querySelector('[data-delivery-estimate-title]');
          const range = this.querySelector('[data-delivery-estimate-range]');
          if (!data || !title || !range) return;

          this.titleElement = title;
          this.range = range;
          this.variants = new Map(JSON.parse(data.textContent).map((variant) => [String(variant.id), variant]));
          this.handleVariantChange = this.handleVariantChange.bind(this);
          document.addEventListener('variant-change', this.handleVariantChange);
          this.update(this.dataset.selectedVariantId);
        }

        disconnectedCallback() {
          document.removeEventListener('variant-change', this.handleVariantChange);
        }

        handleVariantChange(event) {
          if (String(event.detail.sectionId) !== this.dataset.sectionId) return;
          this.update(event.detail.variant?.id);
        }

        update(variantId) {
          const variant = this.variants.get(String(variantId));
          if (!variant?.available) {
            this.hidden = true;
            return;
          }

          if (variant.email) {
            this.titleElement.textContent = this.dataset.emailTitle;
            this.range.textContent = this.dataset.emailText;
            this.hidden = false;
            return;
          }

          this.titleElement.textContent = this.dataset.dateTitle;
          const now = this.berlinNow();
          const dispatch = this.nextDispatchDay(now.date, now.hour);
          let earliest = this.addWorkingDays(dispatch, 1);
          let latest = this.addWorkingDays(dispatch, 2);

          if (variant.delayed) {
            earliest = this.addWorkingDays(earliest, 3);
            latest = this.addWorkingDays(latest, 3);
          }

          const format = new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'UTC',
          });

          this.range.textContent = this.dataset.rangeTemplate
            .replace('__FROM__', format.format(earliest))
            .replace('__TO__', format.format(latest));
          this.hidden = false;
        }

        berlinNow() {
          const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            hourCycle: 'h23',
          }).formatToParts(new Date());
          const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));

          return {
            date: new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12)),
            hour: Number(values.hour),
          };
        }

        nextDispatchDay(date, hour) {
          const result = new Date(date);
          if (this.isDispatchDay(result) && hour < 8) return result;

          do {
            result.setUTCDate(result.getUTCDate() + 1);
          } while (!this.isDispatchDay(result));

          return result;
        }

        isDispatchDay(date) {
          const day = date.getUTCDay();
          return day >= 2 && day <= 6;
        }

        addWorkingDays(date, days) {
          const result = new Date(date);
          let remaining = days;

          while (remaining > 0) {
            result.setUTCDate(result.getUTCDate() + 1);
            if (result.getUTCDay() !== 0) remaining -= 1;
          }

          return result;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
